import placeService from "@/services/placeService";

const state = {
    places: [],
};

const actions = {
    getPlaces(store, params) {
        return new Promise((resolve, reject) => {
            placeService.fetchPlaces(params)
                .then((response) => {
                    store.commit("addPlaces", response.items);
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
};

const mutations = {
    addPlaces(state, places) {
        // add unique places
        places.forEach((place) => {
            if (!state.places.find((p) => p.id === place.id)) {
                state.places.push(place);
            }
        });
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
}